import React, { useState, useCallback, forwardRef } from "react"
import styled, { css } from 'styled-components'
import { theme } from '../../../GlobalStyle'

import { useSpring, animated as a } from 'react-spring'

const Button = styled(a.button)`
  ${({ theme: { color, font } }) => css`
    display: block;
    width: 100%;
    padding: 2rem 0;
    color: ${color.bg};
    font-family: ${font.en};
    font-size: 1.6rem;
    font-weight: 500;
    letter-spacing: 0.15rem;
  `}
`

const MenuButton = forwardRef(({ children, ...props }, ref) => {
  
  const { isOpen, setOpen } = props
  const [isHover, setIsHover] = useState(false)
  const { color, background } = useSpring ({
    color: isHover ? theme.color.white : theme.color.bg,
    background: isHover ? 'rgba(255, 255, 255, 0.01)' : 'rgba(255, 255, 255, 0)'
  })

  let isStopped = false
  const [, setY] = useSpring(() => ({ y: 0 }))

  const onWheel = () => {
    isStopped = true
    window.removeEventListener('wheel', onWheel)
  }

  const handleClick = () => {
    const target = ref.current
    const offsetY = 60
    const value = window.scrollY + target.getBoundingClientRect().top - offsetY
    // const value = (() => {
    //   if (window.screenY + target.getBoundingClientRect().top < 0) {
    //     return 0
    //   // } else if (window.scrollY + target.getBoundingClientRect().bottom > document.body.clientHeight) {
    //   //   return document.body.clientHeight - window.innerHeight
    //   } else {
    //     return window.scrollY + target.getBoundingClientRect().top - offsetY
    //   }
    // })
    // window.addEventListener('wheel', onWheel)

    setY({
      y: value < 0 ? 0 : value,
      reset: true,
      from: { y: window.scrollY },
      onRest: () => {
        window.removeEventListener('wheel', onWheel)
        isStopped = false
      },
      onFrame: props => {
        if (!isStopped) {
          window.scroll(0, props.y)
        }
      }
    })
    setOpen(!isOpen)
  }

  const handleMouseEnter = useCallback(() => {
    setIsHover(true)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setIsHover(false)
  }, [])

  return (
    <Button
      style={{ color, background }}
      aria-label={`Scroll to ${children}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}>
      {children}
    </Button>
  )
})

export default MenuButton